const index = () => import(/* webpackChunkName: "incentive" */ './Index');
const history = () => import(/* webpackChunkName: "incentive" */ './history');



export default {
  routes: [
    //项目
    {
      path: '/special/index',
      name: 'special_specialIndex',
      component: index
    },
    {
      path: '/special/history',
      name: 'special_specialHistory',
      component: history
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/index/router.js